"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoodsTableHead = void 0;
// 导出TableHead 数据
var GoodsTableHead = exports.GoodsTableHead = [{
  title: '图片',
  slot: 'image',
  align: 'center',
  minWidth: 60
}, {
  title: '兑换金额（元）',
  slot: 'price',
  align: 'center',
  minWidth: 120
}, {
  title: '兑换积分',
  slot: 'redeemIntegral',
  align: 'center',
  minWidth: 100
}, {
  title: '划线价',
  slot: 'cost',
  align: 'center',
  minWidth: 100
}, {
  title: '库存',
  slot: 'stock',
  align: 'center',
  minWidth: 100
}, {
  title: '商品编码',
  slot: 'barCode',
  align: 'center',
  minWidth: 120
}, {
  title: '重量（KG）',
  slot: 'weight',
  align: 'center',
  minWidth: 90
}, {
  title: '体积(m³)',
  slot: 'volume',
  align: 'center',
  minWidth: 90
}, {
  title: '默认选中规格',
  slot: 'isDefault',
  fixed: 'right',
  align: 'center',
  minWidth: 100
}, {
  title: '操作',
  slot: 'action',
  fixed: 'right',
  align: 'center',
  minWidth: 120
}];